module.exports = __webpack_public_path__ + "static/media/lock.c6874cb9.svg";